module.exports = __webpack_public_path__ + "989b107777c8b862a8904b1a694be1ac.svg";